export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#1E5A8E] to-[#2F7FB7] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand column */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/60c09a59e0fb28552f21c009d5db8614/9d6b92f26044a717beee1d11c21ed422.png" 
                alt="Recover Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-2xl font-serif font-semibold">RECOVER</span>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              A calm, supportive space for your mental health journey.
            </p>
          </div>

          {/* Resources column */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Features
                </a>
              </li>
              <li>
                <a href="#self-assessments" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Self-Assessments
                </a>
              </li>
              <li>
                <a href="#masterclass" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Masterclass Series
                </a>
              </li>
              <li>
                <a href="#resources" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Meditation & Music
                </a>
              </li>
            </ul>
          </div>

          {/* Support column */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Support</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Help Center
                </a>
              </li>
              <li>
                <a href="/contact" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/80 text-sm">
              © 2025 RECOVER. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="/privacy-policy" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="/terms-of-service" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer" target="_blank" rel="noopener noreferrer">
  
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
